import { render, staticRenderFns } from "./DispatcherWash.vue?vue&type=template&id=551dfd6e&scoped=true&"
import script from "./DispatcherWash.vue?vue&type=script&lang=js&"
export * from "./DispatcherWash.vue?vue&type=script&lang=js&"
import style0 from "./DispatcherWash.vue?vue&type=style&index=0&id=551dfd6e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "551dfd6e",
  null
  
)

export default component.exports